export const getUserLocaleLocalStorageKey = ({ environmentId, 
// siteId,
axonUserId, }) => {
    return `lumos_user_locale_${environmentId}_${axonUserId}`;
};
export const getUserSiteSelectionLocalStorageKey = ({ environmentId, axonUserId, }) => {
    return `lumos_user_selected_site_${environmentId}_${axonUserId}`;
};
export const getUseLocalCortextSessionStorageKey = () => {
    return 'lumos_use_local_cortex_session';
};
